/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Beneficiary } from "./Beneficiary";

export const productSPRSamplingIntervals = [
    { name: "month", label: "Mensuel" },
    { name: "trimester", label: "Trimestriel" },
];

export const productSPRBeneficiaryClauseItems = [
    { name: "standard", label: "Clause standard : le conjoint de l'assuré non séparé judiciairement, à défaut les enfants de l'assuré " +
        "nés ou à naître, vivants ou représentés, à défaut les héritiers de l'assuré." },
    { name: "beneficiary", label: "Clause libre : autre(s) bénéficiaire(s). " +
        "Merci de renseigner précisément les informations ci-dessous." },
];

export interface ProductSPR {
    annuityAge85?: number;
    annuityImmediate?: number;

    contribution?: number;
    samplingInterval?: "month" | "trimester";

    beneficiaryClause?: "standard" | "beneficiary";
    beneficiaries: Beneficiary[];

    availableQuotePart?: number; // TODO
}


// WEBPACK FOOTER //
// ./src/types/ProductSPR.ts